import { render, staticRenderFns } from "./FoodcourtOrderBoard.vue?vue&type=template&id=70160931"
import script from "./FoodcourtOrderBoard.vue?vue&type=script&lang=js"
export * from "./FoodcourtOrderBoard.vue?vue&type=script&lang=js"
import style0 from "./FoodcourtOrderBoard.vue?vue&type=style&index=0&id=70160931&prod&lang=scss"
import style1 from "./FoodcourtOrderBoard.vue?vue&type=style&index=1&id=70160931&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports